<template >
	<BasicLayout>
		<div v-loading="loading">

			<!-- Entête -->
			<div v-bind:class="backgroundColor" class="checkupTop">      
				<div class="checkupTitleTop">
					<span class="checkupTopText ">
						{{ victim.lastname }} {{ victim.firstname }}
						<span class="hidden-xs-only">
							- <age v-bind:value="victim.age" v-bind:type="victim.ageType" v-if="victim.age" /> {{victim.gender}} <span v-if="victim.weight">{{victim.weight}} kg</span>
							- {{ all.fireunit }}, {{ all.vehicle }}
						</span>
						<el-popover
							class="hidden-sm-and-up"
							trigger="click">
							<div>
								<b>Age :</b> <age v-bind:value="victim.age" v-bind:type="victim.ageType" v-if="victim.age" /><br>
								<b>Sexe :</b> {{victim.gender}}<br>
								<b>Poids :</b> <span v-if="victim.weight">{{victim.weight}} kg</span><br>
								<b>Centre :</b> {{ all.fireunit }}<br>
								<b>Engin :</b> {{ all.vehicle }}<br>
							</div>
							<i slot="reference" class="fas fa-info-circle" style="margin-left: 5px;"></i>
  						</el-popover>
					</span>
				</div>
				<div class="checkupActionTop" >
					<div class="divSelectOrder">
						<span class="hidden-xs-only">Heure du bilan: </span>
						<el-select  v-model="receiptDateSelected" placeholder="" @change="clickOrder" size="small" class="selectOrder">
							<el-option v-for="n in history" :key="n.code" :label="n.name" :value="n.code"></el-option>
						</el-select>
					</div>
					<el-button-group v-if="!!html">
						<el-button size="small" icon="far fa-copy" class="copyButton" v-on:click="getCopy()" title="Copier la Synthèse" ></el-button>
						<el-button size="small" icon="fas fa-download" class="printButton" v-on:click="getPDF()" title="Télécharger le pdf de la Synthèse"></el-button>
					</el-button-group>
				</div>     
			</div>

			<!-- Saisie destination + observation + prescriptions -->
			<el-row :gutter="20" class="checkupMiddle" v-if="isCrraOrSdisOrSystem || victim.observationCRA || totalPrescriptions > 0" v-bind:class="{'editable' : isCrraOrSystem}">
				<el-col v-if="isCrraOrSdisOrSystem" :md="4" :sm="6" :xs="8" @click.native="openEditDest()">
					<div style="min-width: 52px;">
						<i class="fas fa-lg fa-clinic-medical label-icon" title="Devenir (CRRA)"></i>
						<i class="fas fa-edit editable-icon" v-if="isCrraOrSystem"></i>
						<span v-if="!editDest && destId != 'NO_TRANSP'">{{ victim.destinationCRA }}</span>
						<span v-if="!editDest && destId == 'NO_TRANSP'"><i class="fas fa-ban" style="color: tomato"></i>&nbsp;Pas de transport</span>
					</div>
					<div v-if="editDest" class="edit">
						<el-select v-model="destId" filterable placeholder="Destination" size="small" class="dest-select">
							<el-option-group label="Autre">
								<el-option :value="'NO_TRANSP'" :label="'Pas de transport'">
									<div><i class="fas fa-ban" style="color: tomato"></i>&nbsp;Pas de transport</div>
								</el-option>
							</el-option-group>
							<el-option-group label="SAU référencés">
								<el-option
									v-for="entity in entitiesSAU"
									:key="entity.id"
									:label="entity.name"
									:value="entity.id"
									class="entity-option">
									<div>{{ entity.name }}</div>
									<div class="subtext">{{ entity.address }}</div>
								</el-option>
							</el-option-group>
							<el-option-group label="Destination éphémères">
								<el-option
									v-for="tmpUser in tmpUsers"
									:key="tmpUser.id"
									:value="tmpUser.id"
									:label="tmpUser.lastname + (tmpUser.firstname ? ' ' + tmpUser.firstname : '')"
									class="entity-option">
									<div>{{ tmpUser.lastname }} {{ tmpUser.firstname }}</div>
									<div class="subtext">{{ tmpUser.email }}</div>
								</el-option>
							</el-option-group>
						</el-select>
						<div class="edit-icons">
							<i class="fas fa-fw fa-lg fa-save vert-color hover" title="Enregistrer" v-on:click.stop="saveDest()"></i>
							<i class="fas fa-fw fa-lg fa-times rouge-color hover" title="Annuler" v-on:click.stop="editDest = false"></i>
						</div>
					</div>
				</el-col>
				<el-col 
					:lg="isCrraOrSdisOrSystem ? 18 : 22" 
					:md="isCrraOrSdisOrSystem ? 17 : 21" 
					:sm="isCrraOrSdisOrSystem ? 15 : 21" 
					:xs="isCrraOrSdisOrSystem ? 10 : 18" 
					@click.native="openEditObs()">
					<div style="min-width: 52px;">
						<i class="far fa-lg fa-comment label-icon" title="Observation (CRRA)"></i>
						<i class="fas fa-edit editable-icon" v-if="isCrraOrSystem"></i>
						<span v-if="!editObs">{{ victim.observationCRA }}</span>
					</div>
					<div v-if="editObs" class="edit">
						<el-input 
							placeholder="Observation" 
							v-model="editObsVal"
							type="textarea"
							:autosize="{minRows: 1, maxRows: 4}"
							maxlength="500"
							show-word-limit>
						</el-input>
						<div class="edit-icons">
							<i class="fas fa-fw fa-lg fa-save vert-color hover" title="Enregistrer" v-on:click.stop="saveObs()"></i>
							<i class="fas fa-fw fa-lg fa-times rouge-color hover" title="Annuler" v-on:click.stop="editObs = false"></i>
						</div>
					</div>
				</el-col>
				<el-col v-if="checkup.versionV2" :lg="2" :md="3" :sm="3" :xs="6" @click.native="showPrescriptions=true" style="cursor: pointer;" title="Prescriptions">
					<div style="min-width: 52px;">
						<i class="fas fa-lg fa-prescription label-icon"></i>
						<i class="fas fa-edit editable-icon" v-if="isCrraOrSystem"></i>
						<el-tag type="info" size="mini" effect="dark" class="prescription-total-tag">{{ totalPrescriptions }}</el-tag>
					</div>
				</el-col>
			</el-row>

			<!-- Prescriptions -->
			<el-card v-if="showPrescriptions" class="prescriptions">
				<Prescriptions v-bind:items="prescriptions" v-bind:victimId="victim.id" @hide-prescriptions="hidePrescriptions" />
			</el-card>

			<!-- Bilan -->
			<el-tabs v-if="!showPrescriptions" type="border-card" v-bind:class="{ 'editing' : (editObs || editDest) }" class="checkupBottom" @tab-click="clickTab">
				<el-tab-pane label="Synthèse" v-show="!!html"><CheckupPart0 v-bind:synthese="html"/></el-tab-pane>
				<el-tab-pane>
					<span slot="label">
						<span v-if="checkup.versionV2">Circ<span class="hidden-sm-and-down">onstances</span> / Admin<span class="hidden-sm-and-down">istration</span> / TEP</span>
						<span v-else>Admin<span class="hidden-xs-only">istration</span></span>
					</span>
					<CheckupPart1 v-bind="{ administration: administration, initTab: initTabAdmin}"/>
				</el-tab-pane>
				<el-tab-pane label="Bilan"><CheckupPart2 v-bind="{ checkup: checkup, column : columnCheckup}"/></el-tab-pane>
				<el-tab-pane label="Prescription" v-if="checkup.versionV2"><CheckupPart3 v-bind:column="presc"/></el-tab-pane>
				<el-tab-pane v-if="checkup.versionV2">
					<span slot="label" class="capitalize">
						<span class="hidden-sm-and-down">Complément</span> infirmier
					</span>
					<CheckupPart3 v-bind:column="inf"/>
				</el-tab-pane>
				<el-tab-pane v-if="checkup.versionV2">
					<span slot="label" class="capitalize">
						<span class="hidden-sm-and-down">Complément</span> médecin
					</span>
					<CheckupPart3 v-bind:column="med"/>
				</el-tab-pane>
				<el-tab-pane label="Surveillance"><CheckupPart3 v-bind:column="surv"/></el-tab-pane>
				<el-tab-pane label="Devenir"><CheckupPart4 v-bind="{ column:devenir, textSign:textSign }"/></el-tab-pane>          
				<el-tab-pane name="photo-tab" v-if="fileCount> 0">
					<span slot="label">						
						<span v-if="checkup.versionV2">Pièces jointes</span>
						<span v-else>Photo</span>
						<el-badge class="mark badge-file-count" :value="fileCount" type="info" />  
					</span>
					<CheckupPart5 ref="photoTab" :files="files" />
				</el-tab-pane>
			</el-tabs>
		</div>
	</BasicLayout>
</template>

<script>
import BasicLayout from "@/layouts/basic.layout.vue"
import CheckupPart0 from '@/components/checkup.part0.component.vue'
import CheckupPart1 from '@/components/checkup.part1.component.vue'
import CheckupPart2 from '@/components/checkup.part2.component.vue'
import CheckupPart3 from '@/components/checkup.part3.component.vue'
import CheckupPart4 from '@/components/checkup.part4.component.vue'
import CheckupPart5 from '@/components/checkup.part5.component.vue'
import Prescriptions from '@/components/prescriptions/prescriptions.component.vue'
import Age from '@/components/age.component.vue'
import CheckupService from '@/services/checkup.service'
import UserService from '@/services/user.service'
import VictimService from '@/services/victim.service'
import EntityService from '@/services/entity.service'
import EntityTypes from '@/constants/entity.types.const.js'
import StringUtils from '@/utils/string.utils'
import '@/style/theme/index.css'

export default {    
	components: {
		BasicLayout,
		CheckupPart0,
		CheckupPart1,
		CheckupPart2,
		CheckupPart3,
		CheckupPart4,
		CheckupPart5,
		Prescriptions,
		Age,
		CheckupService
	},

	data() {
		return {
			html:"",
			fileCount: 0,
			files: [],
			administration:{},
			checkup:{},
			presc:{},
			inf:{},
			med:{},
			surv:{},
			devenir:{},
			victim:{},
			textSign: "",
			all:{},
			columnCheckup:{},
			history:{},
			receiptDateSelected: null,
			loading: true,
			editObs: false,
			editObsVal: '',
			editDest: false,
			entitiesSAU: [],
			tmpUsers: [],
			destId: '',
			initTabAdmin: '',
			showPrescriptions: false,
			prescriptions: []
		}
	},
	
	computed: {
		backgroundColor() {
			if (this.victim.checkupColor == null) {
				return null;
			} else {
				return this.victim.checkupColor.toLowerCase() + '-background';
			}
		},
		user: function() {
			return UserService.getCurrentUser()
		},
		isCrraOrSdisOrSystem: function () {
			return EntityTypes.CRRA === this.user.entityType || EntityTypes.SDIS === this.user.entityType || this.user.hasProfile('SYSTEM')
		},
		isCrraOrSystem: function () {
			return EntityTypes.CRRA === this.user.entityType || this.user.hasProfile('SYSTEM')
		},
		totalPrescriptions: function () {
			return this.prescriptions ? this.prescriptions.length : 0
		}
	},

	methods: {
		getData() {
			// Appel de l'api
			CheckupService.getCheckup(this.$route.params.victimId,this.$route.params.order).then((result) => {

				// On affecte le résultat à "all"
				this.all = result;
				this.victim = result.victim;
				this.textSign = result.textSign;

				// ===========================================================
				// SYNTHESE
				// ===========================================================
				this.html = result.html;

				// Pour supprimer les couleurs de la synthèse
				if (this.html) {
					this.html =  this.html.replace(/(green, green)/g, '');
					this.html =  this.html.replace(/(yellow, green)/g, '');
					this.html =  this.html.replace(/(yellow, yellow)/g, '');
					this.html =  this.html.replace(/(red, red)/g, '');
				}

				// ===========================================================
				// Intervention
				// ===========================================================

				var chlid11 = {libelle : 'Intervention' , value : result.victim.operationNumber  , type: "text"};
				var chlid21 = {libelle : 'Matricule CA' , value : result.victim.leaderNumber , type: "text"};
				var chlid31 = {libelle : 'Engin' , value : result.victim.vehicleName , type: "text"};
				var chlid41 = {libelle : "Centre" , value : result.victim.fireunitName , type: "text"};


				var col1 = { chlid11 , chlid21 , chlid31 , chlid41};
				var col2 = {};
				var col3 = {};
			
				this.administration.inter = {leftTitle:'Intervention',col01: col1 ,col02: col2,col03: col3}

				// ===========================================================
				// Administration
				// ===========================================================

				// initialisation des colonnes (premier affichage)
				if (result.versionV2) {
					this.initTabAdmin = 'circ';
				} else {
					this.initTabAdmin = 'admin';
				}

				// Données
				let detailAdmin = result.detail.find((detail) => detail.id === 'victime')
				if (detailAdmin) {
					this.administration.admin = detailAdmin;
				}
				let detailCirc = result.detail.find((detail) => detail.id === 'circ')
				if (detailCirc) {
					this.administration.circ = detailCirc;
				}

				// TEP seulement si V2 et enfant
				if (result.versionV2 && result.child ) {
					let detailTep = result.detail.find((detail) => detail.id === 'tep')
					if (detailTep) {
						this.administration.tep = detailTep;
					}
				}

				// ===========================================================
				// checkup                
				// ===========================================================

				// initialisation des colonnes (premier affichage)
				this.columnCheckup = {leftTitle: result.detail[0].libelle, col01 : result.detail[0].child1, col02 : result.detail[0].child2, col03 : result.detail[0].child3};                

				// Données
				let detailA = result.detail.find((detail) => detail.id === 'a')
				if (detailA) {
					this.checkup.a = detailA;
				}
				let detailB = result.detail.find((detail) => detail.id === 'b')
				if (detailB) {
					this.checkup.b = detailB;
				}
				let detailC = result.detail.find((detail) => detail.id === 'c')
				if (detailC) {
					this.checkup.c = detailC;
				}
				let detailD = result.detail.find((detail) => detail.id === 'd')
				if (detailD) {
					this.checkup.d = detailD;
				}
				let detailE = result.detail.find((detail) => detail.id === 'e')
				if (detailE) {
					this.checkup.e = detailE;
				}
				let detailSample = result.detail.find((detail) => detail.id === 'sample' || detail.id === 'sampler')
				if (detailSample) {
					this.checkup.s1 = detailSample;
				}
				let detailOpqrst = result.detail.find((detail) => detail.id === 'opqrst' )
				if (detailOpqrst) {
					this.checkup.s2 = detailOpqrst;
				}
				let detailFast = result.detail.find((detail) => detail.id === 'fast')
				if (detailFast) {
					this.checkup.s3 = detailFast;
				}
				let detailLesions = result.detail.find((detail) => detail.id === 'lesions')
				if (detailLesions) {
					this.checkup.s4 = detailLesions;
				}
				let detailDAE = result.detail.find((detail) => detail.id === 'dae')
				if (detailDAE) {
					this.checkup.s5 = detailDAE;
				}

				// Version V2
				this.checkup.versionV2 = result.versionV2;
					
				// ajout du sexe pour les lesions
				this.checkup.gender = result.victim.gender;

				// ===========================================================
				// SURVEILLANCE
				// ===========================================================
				let detailSurveillance = result.detail.find((detail) => detail.id === 'surveillance')
				if (detailSurveillance) {
					this.surv = {leftTitle: detailSurveillance.libelle, col01 : detailSurveillance.child1, col02 : detailSurveillance.child2, col03 : detailSurveillance.child3};
				}
				
				// ===========================================================
				// DEVENIR
				// ===========================================================
				let detailDevenir = result.detail.find((detail) => detail.id === 'devenir')
				if (detailDevenir) {
					this.devenir = {leftTitle: detailDevenir.libelle, col01 : detailDevenir.child1, col02 : detailDevenir.child2, col03 : detailDevenir.child3};
				}

				// ===========================================================
				// GROSSESSE
				// ===========================================================
				// Test pour afficher l'onglet grossesse dans le bilan
				this.columnCheckup.s6Visible = false;
				let detailGrossesse = result.detail.find((detail) => detail.id === 'grossesse')
				if (detailGrossesse) {
					this.checkup.s6 = detailGrossesse;
					this.columnCheckup.s6Visible = true;
				} 

				if (result.versionV2) {				
					// ===========================================================
					// PRESCRIPTION
					// ===========================================================
					let detailPrescription = result.detail.find((detail) => detail.id === 'prescription')
					if (detailPrescription) {
						this.presc = {leftTitle: detailPrescription.libelle, col01 : detailPrescription.child1, col02 : detailPrescription.child2, col03 : detailPrescription.child3};
					}

					// ===========================================================
					// COMPLEMENT INFIRMIER
					// ===========================================================
					let detailInfirmier = result.detail.find((detail) => detail.id === 'infirmier')
					if (detailInfirmier) {
						this.inf = {leftTitle: detailInfirmier.libelle, col01 : detailInfirmier.child1, col02 : detailInfirmier.child2, col03 : detailInfirmier.child3};
					}

					// ===========================================================
					// COMPLEMENT MEDECIN
					// ===========================================================
					let detailMedecin = result.detail.find((detail) => detail.id === 'medecin')
					if (detailMedecin) {
						this.med = {leftTitle: detailMedecin.libelle, col01 : detailMedecin.child1, col02 : detailMedecin.child2, col03 : detailMedecin.child3};
					}

				}

				// ===========================================================
				// Fichiers
				// ===========================================================           
				this.fileCount = result.fileCount;
				this.files = result.files || []

				// ===========================================================
				// Numéro d'ordre
				// ===========================================================
				this.receiptDateSelected = this.$route.params.order;
				this.history = result.receiptDate;

				// ===========================================================
				// Fixe l'id de destination (pour la saisie)
				// ===========================================================
				if (result.victim.entityId) {
					this.destId = result.victim.entityId
				}
				else if (result.victim.tmpUserId) {
					this.destId = 't' + result.victim.tmpUserId
				}
				else if (!result.victim.transportCRA) {
					this.destId = 'NO_TRANSP'
				}

				// ===========================================================
				// Prescriptions
				// ===========================================================
				this.prescriptions = result.prescriptions

				if (this.$route.query && this.$route.query.showPrescriptions && result.versionV2) {
					this.showPrescriptions = true
				}

				this.loading = false;
			})
		},

		clickOrder() {
			this.$router.push('/checkups/' + this.$route.params.victimId + '/' + this.receiptDateSelected);
			this.$router.go();  
		},
		
		getPDF() {
			CheckupService.downloadSynthesisPDF(this.$route.params.victimId,this.$route.params.order);
		},
	
		getCopy() {
			// On traite la chaine html pour avoir un format texte
			var str = this.html.replace(/<h1[^>]*>/g, '\n\n==========================\n');
			str = str.replace(/<.h1[^>]*>/g, '\n==========================');
			str = str.replace(/<h2[^>]*>/g, '\n\n');
			str = str.replace(/<.h2[^>]*>/g, '\n**************************');
			str = str.replace(/<h4[^>]*>/g, '\n');
			str = str.replace(/<li[^>]*>/g, '\n- ');
			str = str.replace(/<p[^>]*>/g, '\n');  
			
			// Retire toutes les autres balises HTML
			// En préservant les '<' et '>' dans le texte
			var tmp = document.createElement('DIV');
			tmp.innerHTML = str;
			str = tmp.textContent || tmp.innerText || '';

			// Create new element
			var el = document.createElement('textarea');
			// Set value (string to be copied)
			el.value = str;
			// Set non-editable to avoid focus and move outside of view
			el.setAttribute('readonly', '');
			document.body.appendChild(el);
			// Select text inside element
			el.select();
			// Copy text to clipboard
			document.execCommand('copy');
			// Remove temporary element
			document.body.removeChild(el);

			// Notification de la copie
			this.$notify({
				title: 'Synthèse copiée',
				message: 'La copie de la synthèse se situe dans le presse-papier',
				type: 'success',
				position: 'bottom-right'
			});
		},

		clickTab(tab) {
			// Chargement des photos
			if (tab.name === 'photo-tab') {
				this.$refs.photoTab.loadFiles();
			}
		},

		openEditObs() {
			if (!this.editObs && this.isCrraOrSystem) {
				this.editObs = true
				this.editObsVal = this.victim.observationCRA
			}
		},

		hidePrescriptions() {
			this.showPrescriptions = false
		},

		saveObs() {

			this.loading = true

			// Appel de l'api
			VictimService.updateObs(this.victim.id, this.editObsVal).then((vict) => {

				this.victim.observationCRA = vict.observationCRA
				this.editObs = false
				this.loading = false
			})
		},

		openEditDest() {
			if (!this.editDest && this.isCrraOrSystem) {
				this.editDest = true
			}
		},
		saveDest() {

			this.loading = true

			// Appel de l'api
			VictimService.updateDest(this.victim.id, this.destId).then((vict) => {

				// Fixe l'id de destination
				if (vict.entityId) {
					this.destId = vict.entityId
				}
				else if (vict.tmpUserId) {
					this.destId = 't' + vict.tmpUserId
				}
				else if (!vict.transportCRA) {
					this.destId = 'NO_TRANSP'
				}

				this.victim.destinationCRA = vict.destinationCRA
				this.victim.checkupState = vict.checkupState
				this.editDest = false
				this.loading = false
			})
		}
	},

	mounted: function() {

		if (this.isCrraOrSystem) {

			// Charge et tri la liste des entités de type SAU
			EntityService.getEntities(true).then((entities) => {
				this.entitiesSAU = entities
				this.entitiesSAU.sort((a, b) => StringUtils.compareIgnoreCase(a.name, b.name));
			})

			// Charge et tri la liste des utilisateurs éphémères
			UserService.getTemporariesUsers(true).then((tmpUsers) => {
				this.tmpUsers = tmpUsers
				this.tmpUsers.sort((a, b) => StringUtils.compareIgnoreCase(a.lastname+a.firstname, b.lastname+b.firstname));

				// Pour chaque utilisateur éphémère
				// Rajoute le caractère 't' devant l'id
				// pour éviter la collision avec les id des entités
				this.tmpUsers.forEach(tmpUser => {
					tmpUser.id = 't' + tmpUser.id
				})
			})
		}

		// Charge le bilan
		this.getData();
	}
};
</script>

<style>

	.el-tabs__content {
		overflow-y: scroll;
		height: calc(100vh - 297px);
		min-height: 300px;
	}

	.checkupBottom.editing .el-tabs__content {
		height: calc(100vh - 320px);
	}

	.prescriptions {
		height: calc(100vh - 240px);
		border-radius: 0 0 10px 10px !important;
	}

	.prescriptions-title {
		margin-top: 0;
	}

	.width-td-md {
		width: 33.33%
	}

	td {
		vertical-align:top;
	}

	.border-r{
		border-right-width: 6px;
		border-right-style: solid;
		border-color: white;
	}

	.border-l{
		border-left-width: 3px;
		border-left-style: solid;
		border-color: white;
	}

	.checkupTitleTop{
		width: calc(100% - 270px);
		display: inline-block;
		padding: 3px 0px 3px 0px !important;
	}

	.checkupActionTop{
		width: 270px;
		display: inline-block;
		padding: 3px 0px 3px 0px !important;
		text-align: right;
	} 

	.checkupTop{ 
		width: 100%;
		border-radius: 10px 10px 0px 0px !important;
	}

	.printButton{
		margin: 0px 4px 0px 0px !important;
		border-radius: 0px 10px 4px 0px !important;
	}

	.copyButton{
		border-radius: 4px 0px 0px 4px !important;
	}

	.selectOrder{
		width: 85px;
	}
	
	.divSelectOrder{
		display: inline-block;
		vertical-align: middle;
		margin-right: 5px;
	}

	.checkupBottom{ 
		font-size: 13px;
		border-radius: 0px 0px 10px 10px !important;
	}

	.checkupTopText{ 
		margin: 20px;
		font-size: 14px;
	}
		
	.rouge-checkupGravity{
		background-image: linear-gradient(to right, rgb(255, 0, 0),rgba(255, 0, 0,0.8));
		color:white;
	}

	.vert-checkupGravity{
		background-image: linear-gradient(to right, rgb(100, 210, 0),rgba(100, 210, 0,0.8));
	}

	.jaune-checkupGravity{
		background-image: linear-gradient(to right, rgb(235, 235, 20), rgba(235, 235, 20,0.8));
	}

	.vertjaune-checkupGravity{
		background-image: linear-gradient(to right, rgb(235, 235,0), rgba(100, 210, 0,0.9));
	}

	.blanc-checkupGravity{
		background-image: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.8));
	}

/* =============================================  
	Observation + destination
   =============================================
*/

	.checkupMiddle {
		background-color: aliceblue;
		border-left: 1px solid #DCDFE6;
		border-right: 1px solid #DCDFE6;
		margin-left: 0 !important;
		margin-right: 0 !important;
		box-shadow: 0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);
	}

	.checkupMiddle .el-col {
		display: flex;
		padding: 5px;
	}

	.checkupMiddle.editable .el-col {
		cursor: pointer;
	}

	.checkupMiddle.editable .el-col:hover {
		background-color: #e6f3ff;
	}

	.checkupMiddle.editable .el-col:hover .editable-icon {
		color: #409EFF;
	}

	.checkupMiddle .editable-icon {
		color: #999;
	}

	.checkupMiddle .label-icon, .checkupMiddle .editable-icon {
		margin-right: 10px;
	}

	.checkupMiddle .edit {
		display: flex;
		width: 95%;
	}

	.checkupMiddle .dest-select {
		width: 100%;
	}

	.checkupMiddle .edit-icons {
		width: 38px;	
	}

	.entity-option {
		height: 46px;
		line-height: 20px;
	}

	.subtext {
		color: #8492a6;
		font-size: 10.5px;
	}

	.prescription-total-tag {
		height: 15px;
		line-height: 14px;
	}

	.badge-file-count {
		margin-left: 5px;
	}

/*	=============================================  
	Texte au dessus des boutons  + boutons
	=============================================
*/

	/* taille,couleur,position titre */
	.titreFont {
		font-size: 22px;
		color: rgb(240, 159, 38);
		text-align: center;
	}

	/* Position de Primaire */
	.primPos {
		text-align: start;
	}

	/* Position de Secondaire */
	.secondPos {
		text-align: right;
	}

	/* taille et couleur prim et second */
	.primSecondFont {
		font-size: 16px;
		color: dimgray;
	}

	/* taille bouton */
	.btn-select {
		padding-left: 15px;
		padding-right: 15px;
	}

/*	=============================================  
	Contenu + bandeau 
	=============================================
*/

	.title2 {
		text-align: center;
		font-size: 16px;
		padding: 1px;
	}

	/* Contenant */
	.divTable {
		display: table;
		width: 100%;
		table-layout: fixed;
		vertical-align: middle;
	}

	/* contenu principal */
	.table {
		width: 100%;
		height: 100%;
		border-spacing: 0px;
	}

	/* Bandeau du haut mode smartphone  */
	.divCellTop {
		display: table-row;
		font-size: 16px;
		text-align: center;
	}

	/* Bandeau de gauche (sauf mode smartphone) */
	.divCellLeft {
		display: table-cell;
		font-size: 18px;
		width: 28px;
		padding-left: 7px;
		vertical-align: top;
	}

	.divCell {
		display: table-cell;
		font-size: 13px;
	}

	.rotate {
		writing-mode: vertical-lr; 
		transform: rotate(180deg);
		margin-top: -13px;
		padding-bottom: 23px;
		margin-bottom: 10px;
	}

	.capitalize {
		text-transform: capitalize;
	}

/*	=============================================  
	Couleurs 
	=============================================
*/

	/*	Couleurs Administration */
	/*	----------------------------------------------- */
	.colorAdmin {
		color: #ffffff;
		background-color: #a7a7a7;
	}
	
	.colorAdmin-td {
		color: #000000;
		background-color: rgb(243, 243, 243);
	}

	/*	Couleurs A */
	/*	----------------------------------------------- */
	.colorA {
		color: #ffffff;
		background-color: rgb(63, 174, 73);
	}

	.colorA-td {
		color: #000000;
		background-color: rgba(63, 174, 73,0.3);
	}

	.btn-select.focus.colorA {
		color: #000000;
		background-color: rgba(63, 174, 73,0.6);
	}

	.btn-select.colorA:hover {
		color: #000000;
		background-color: rgba(63, 174, 73,0.4);
	}

	/*	Couleurs B */
	/*	----------------------------------------------- */
	.colorB {
		color: #ffffff;
		background-color: rgb(13, 108, 193);
	}
	.colorB-td {
		color: #000000;
		background-color: rgba(13, 108, 193, 0.3);
	}

	.btn-select.focus.colorB {
		color: #000000;
		background-color: rgba(13, 108, 193, 0.6);
	}

	.btn-select.colorB:hover {
		color: #000000;
		background-color: rgba(13, 108, 193, 0.4);
	}

	/*	Couleurs C */
	/*	----------------------------------------------- */
	.colorC {
		color: #ffffff;
		background-color: rgb(210, 35, 43);
	}
	.colorC-td {
		color: #000000;
		background-color: rgba(210, 35, 43, 0.3);
	}

	.btn-select.focus.colorC {
		color: #000000;
		background-color: rgba(210, 35, 43, 0.6);
	}

	.btn-select.colorC:hover {
		color: #000000;
		background-color: rgba(210, 35, 43, 0.4);
	}

	/*	Couleurs D */
	/*	----------------------------------------------- */
	.colorD {
		color: #ffffff;
		background-color: rgb(35, 31, 32);
	}

	.colorD-td {
		color: #000000;
		background-color: rgba(35, 31, 32, 0.3);
	}

	.btn-select.focus.colorD {
		color: #000000;
		background-color: rgba(35, 31, 32, 0.6);
	}

	.btn-select.colorD:hover {
		color: #000000;
		background-color: rgba(35, 31, 32, 0.4);
	}

	/*	Couleurs E */
	/*	----------------------------------------------- */
	.colorE {
		color: #000000;
		background-color: rgb(255, 201, 20);
	}
	.colorE-td {
		color: #000000;
		background-color: rgba(255, 200, 20, 0.2);
	}

	 .btn-select.focus.colorE {
		color: #000000;
		background-color: rgba(255, 200, 20, 0.6);
	}

	.btn-select.colorE:hover {
		background-color: rgba(255, 200, 20, 0.4);
		color: #000000;
	}


	/*   Couleurs SECONDAIRE */
	/*   ----------------------------------------------- */
	.colorS {
		color: #ffffff;
		background-color: rgb(13, 108, 193);
	}
	.colorS-td {
		color: #000000;
		background-color: rgba(13, 108, 193, 0.3);
	}

	.btn-select.focus.colorS {
		color: #000000;
		background-color: rgba(13, 108, 193, 0.6);
	}

	.btn-select.colorS:hover {
		color: #000000;
		background-color: rgba(13, 108, 193, 0.4);
	}

/*  =============================================  
	Classe pour le mode smartphone
	=============================================
*/
@media only screen and (max-width: 767px) {
 
	/*   Position des boutons */
	.primPos {
		text-align: center;
	}
 
	/*   Position des boutons */
	.secondPos {
		text-align: center;
	}

	.checkupTitleTop{
		width: calc(100% - 182px);
	}

	.checkupActionTop{
		width: 182px;
	} 

	.el-tabs__content{
		overflow-y: scroll;
		height: calc(100vh - 252px);
	}

	.prescriptions {
		height: calc(100vh - 185px);
	}
}
</style>